import '@dotlottie/player-component';

function LaptopAnim() {
  return (
    <div className="App">
      <dotlottie-player
        src="https://lottie.host/1e8eb255-e7a1-42cb-b17e-327afb34b55d/piIsgFJoIL.lottie"
        autoplay
        loop
        
        // style=
      />
      
    </div>
  );
}

export default LaptopAnim;